import React from 'react';
import { array } from 'prop-types';
import classNames from 'classnames';

import css from './StripeConnectAccountStatusBox.css';

const BankIcon = (
    <div className={css.wrapperSvg}>
        <svg
            width="45"
            height="33"
            viewBox="0 0 45 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 3.53566V29.5443C1 30.9489 2.13707 32.08 3.54645 32.08H41.5325C42.9427 32.08 44.0789 30.9464 44.0789 29.5443V3.53566C44.0789 2.13112 42.9419 1 41.5325 1H3.54645C2.1363 1 1 2.13363 1 3.53566Z"
                fill="white"
                stroke="black"
                strokeOpacity="0.15"
                strokeWidth="0.921053"
            />
            <path
                d="M13 25.3077H32M29.625 25.3078V15.5252M24.8752 25.3078V15.5252M20.1252 25.3078V15.5252M15.375 25.3078V15.5252M31.7161 13.5274L22.3815 8.13284C22.2402 8.05119 22.0653 8.05476 21.9274 8.14211L13.2311 13.6529C13.1066 13.7318 13.0301 13.868 13.0274 14.0153L13.0081 15.0787C13.0036 15.3239 13.2012 15.5251 13.4465 15.5251H31.3667C31.5346 15.5251 31.6957 15.4617 31.8145 15.3488C31.9333 15.2359 32 15.0828 32 14.9231V14.0291C31.9999 13.9297 31.974 13.8319 31.9244 13.7443C31.8749 13.6568 31.8033 13.5823 31.7161 13.5274Z"
                stroke="#923395"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </div>
);

const ApplePay = (
    <div className={css.wrapperSvg}>
        <svg
            width="45"
            height="33"
            viewBox="0 0 45 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M40.7801 1.00055H3.70117C2.04432 1.00055 0.701172 2.3437 0.701172 4.00055V29.0795C0.701172 30.7364 2.04432 32.0795 3.70117 32.0795H40.7801C42.437 32.0795 43.7801 30.7364 43.7801 29.0795V4.00055C43.7801 2.3437 42.437 1.00055 40.7801 1.00055Z"
                fill="white"
                stroke="black"
                strokeOpacity="0.15"
                strokeWidth="0.921053"
            />
            <path
                d="M12.086 12.7169C11.7111 13.1595 11.1112 13.5086 10.5113 13.4587C10.4363 12.8603 10.73 12.2245 11.0737 11.8318C11.4486 11.3768 12.1047 11.0526 12.6359 11.0277C12.6984 11.651 12.4547 12.2619 12.086 12.7169ZM12.6296 13.5771C11.7611 13.5273 11.0174 14.0695 10.605 14.0695C10.1863 14.0695 9.5552 13.6021 8.86783 13.6145C7.97424 13.627 7.14314 14.1319 6.68698 14.936C5.74965 16.5442 6.44327 18.9253 7.34936 20.2343C7.79302 20.8825 8.32418 21.5931 9.02405 21.5682C9.68643 21.5433 9.94888 21.1381 10.7487 21.1381C11.5548 21.1381 11.786 21.5682 12.4859 21.5557C13.2108 21.5433 13.667 20.9075 14.1106 20.2592C14.6168 19.5237 14.823 18.8068 14.8355 18.7694C14.823 18.757 13.4357 18.2271 13.4233 16.6314C13.4108 15.2975 14.5168 14.6617 14.5668 14.6243C13.9419 13.7018 12.9671 13.6021 12.6296 13.5771ZM17.6475 11.7695V21.4872H19.1597V18.1648H21.2531C23.1652 18.1648 24.5087 16.8558 24.5087 14.9609C24.5087 13.066 23.1902 11.7695 21.3031 11.7695H17.6475ZM19.1597 13.0411H20.9031C22.2154 13.0411 22.9653 13.7392 22.9653 14.9671C22.9653 16.1951 22.2154 16.8995 20.8969 16.8995H19.1597V13.0411ZM27.2707 21.562C28.2206 21.562 29.1016 21.082 29.5016 20.3215H29.5328V21.4872H30.9326V16.6501C30.9326 15.2476 29.8078 14.3438 28.0768 14.3438C26.4709 14.3438 25.2836 15.2601 25.2399 16.5192H26.6021C26.7146 15.9208 27.2707 15.5281 28.0331 15.5281C28.9579 15.5281 29.4766 15.9582 29.4766 16.7499V17.2859L27.5894 17.3981C25.8335 17.5041 24.8837 18.2209 24.8837 19.4676C24.8837 20.7267 25.8647 21.562 27.2707 21.562ZM27.6769 20.4088C26.8708 20.4088 26.3584 20.0223 26.3584 19.4302C26.3584 18.8193 26.8521 18.464 27.7956 18.4079L29.4766 18.3019V18.8505C29.4766 19.7605 28.7017 20.4088 27.6769 20.4088ZM32.801 24.1301C34.2757 24.1301 34.9693 23.5691 35.5755 21.8674L38.2312 14.4373H36.694L34.9131 20.1782H34.8818L33.1009 14.4373H31.52L34.082 21.5121L33.9445 21.9422C33.7133 22.6715 33.3384 22.952 32.6698 22.952C32.551 22.952 32.3198 22.9395 32.2261 22.927V24.0927C32.3136 24.1176 32.6885 24.1301 32.801 24.1301Z"
                fill="#202020"
            />
        </svg>
    </div>
);

const GooglePay = (
    <div className={css.wrapperSvg}>
        <svg
            width="44"
            height="33"
            viewBox="0 0 44 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.460449 3.53612V29.5439C0.460449 30.9484 1.59751 32.0795 3.0069 32.0795H40.9929C42.4031 32.0795 43.5394 30.9459 43.5394 29.5439V3.53612C43.5394 2.13164 42.4023 1.00055 40.9929 1.00055H3.0069C1.59675 1.00055 0.460449 2.13414 0.460449 3.53612Z"
                fill="white"
                stroke="black"
                strokeOpacity="0.15"
                strokeWidth="0.921053"
            />
            <path
                d="M21.638 13.4036V16.6098H23.682C24.1689 16.6098 24.5715 16.4516 24.89 16.135C25.2169 15.8191 25.3807 15.4424 25.3807 15.0064C25.3807 14.5791 25.2169 14.2068 24.89 13.8903C24.5715 13.5656 24.1689 13.4029 23.682 13.4029H21.638V13.4036ZM21.638 17.7384V21.4576H20.417V12.2751H23.6554C24.4783 12.2751 25.1768 12.5403 25.7523 13.0702C26.3364 13.6 26.6283 14.2457 26.6283 15.0064C26.6283 15.7847 26.3363 16.4347 25.7523 16.9558C25.1858 17.4775 24.4866 17.7377 23.6554 17.7377H21.638V17.7384Z"
                fill="#5F6368"
            />
            <path
                d="M27.8624 19.5339C27.8624 19.8417 27.9974 20.0982 28.2675 20.3034C28.5374 20.5086 28.8537 20.6112 29.2163 20.6112C29.7296 20.6112 30.1869 20.4272 30.5896 20.0601C30.9924 19.6922 31.1933 19.2605 31.1933 18.7651C30.8126 18.4742 30.2817 18.3291 29.6007 18.3291C29.1048 18.3291 28.6914 18.4449 28.36 18.6757C28.0285 18.9065 27.8624 19.1917 27.8624 19.5339ZM29.4422 14.9683C30.3447 14.9683 31.0568 15.2013 31.5794 15.6674C32.1012 16.1335 32.362 16.7725 32.362 17.5845V21.4576H31.1942V20.5855H31.141C30.6367 21.3037 29.964 21.6628 29.1237 21.6628C28.407 21.6628 27.8072 21.4576 27.3255 21.0472C26.8432 20.6368 26.6021 20.1238 26.6021 19.5083C26.6021 18.8582 26.856 18.3415 27.3649 17.9568C27.8738 17.5721 28.5527 17.3793 29.4021 17.3793C30.127 17.3793 30.7246 17.5076 31.1933 17.7641V17.4944C31.1933 17.084 31.025 16.7359 30.6891 16.4493C30.3523 16.1628 29.9594 16.0199 29.5082 16.0199C28.8264 16.0199 28.2872 16.2976 27.8891 16.8539L26.8136 16.1994C27.4066 15.3787 28.2826 14.9683 29.4422 14.9683Z"
                fill="#5F6368"
            />
            <path
                d="M39.0638 15.1735L34.989 24.2278H33.7285L35.2416 21.0597L32.5605 15.1735H33.8877L35.8255 19.6878H35.852L37.7366 15.1735H39.0638Z"
                fill="#5F6368"
            />
            <path
                d="M16.704 16.9367C16.704 16.5651 16.6714 16.2068 16.61 15.8638H11.4604V17.896H14.4099C14.2832 18.5584 13.9002 19.122 13.3193 19.4995V20.8193H15.0795C16.1102 19.9003 16.704 18.5424 16.704 16.9367Z"
                fill="#4285F4"
            />
            <path
                d="M11.4603 22.093C12.9339 22.093 14.1747 21.6255 15.0794 20.8193L13.3192 19.4995C12.8293 19.8183 12.1983 20.0044 11.4603 20.0044C10.0361 20.0044 8.82717 19.0766 8.39488 17.8264H6.58154V19.1858C7.48025 20.9095 9.32695 22.093 11.4603 22.093Z"
                fill="#34A853"
            />
            <path
                d="M8.39503 17.8264C8.2843 17.5076 8.22363 17.1675 8.22363 16.8165C8.22363 16.4655 8.2843 16.1254 8.39503 15.8066V14.4472H6.58169C6.21008 15.1595 6 15.9642 6 16.8165C6 17.6688 6.21008 18.4735 6.58169 19.1858L8.39503 17.8264Z"
                fill="#FABB05"
            />
            <path
                d="M11.4603 13.6286C12.265 13.6286 12.9862 13.8961 13.555 14.4201V14.4208L15.1136 12.9148C14.1671 12.0633 12.9332 11.54 11.4603 11.54C9.32695 11.54 7.48025 12.7236 6.58154 14.4472L8.39488 15.8066C8.82717 14.5564 10.0361 13.6286 11.4603 13.6286Z"
                fill="#E94235"
            />
        </svg>
    </div>
);

const MasterCard = (
    <div className={css.wrapperSvg}>
        <svg
            width="44"
            height="33"
            viewBox="0 0 44 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.460449 3.53612V29.5439C0.460449 30.9484 1.59752 32.0795 3.0069 32.0795H40.9929C42.4031 32.0795 43.5394 30.9459 43.5394 29.5439V3.53612C43.5394 2.13164 42.4023 1.00055 40.9929 1.00055H3.0069C1.59675 1.00055 0.460449 2.13414 0.460449 3.53612Z"
                fill="white"
                stroke="black"
                strokeOpacity="0.15"
                strokeWidth="0.921053"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.4171 7.54004C32.3255 7.54004 36.3045 11.5109 36.3045 16.4092C36.3045 21.3074 32.3255 25.2783 27.4171 25.2783C25.2173 25.2783 23.2041 24.4807 21.6522 23.1595C20.1005 24.4807 18.0873 25.2783 15.8874 25.2783C10.979 25.2783 7 21.3074 7 16.4092C7 11.5109 10.979 7.54004 15.8874 7.54004C18.0873 7.54004 20.1005 8.33766 21.6525 9.65892C23.2041 8.33763 25.2173 7.54004 27.4171 7.54004Z"
                fill="#FF5E00"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8058 7.54004C17.9855 7.54004 19.9802 8.33037 21.5179 9.63953C19.6242 11.2513 18.4237 13.6496 18.4237 16.3277C18.4237 19.0057 19.6242 21.404 21.5173 23.0158C19.9802 24.325 17.9855 25.1153 15.8058 25.1153C10.9425 25.1153 7 21.1809 7 16.3277C7 11.4744 10.9425 7.54004 15.8058 7.54004Z"
                fill="#ED0006"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.3258 7.54004C32.1891 7.54004 36.1315 11.4744 36.1315 16.3277C36.1315 21.1809 32.1891 25.1153 27.3258 25.1153C25.1465 25.1153 23.1521 24.3253 21.6145 23.0166C23.507 21.4048 24.7078 19.0062 24.7078 16.3277C24.7078 13.6492 23.507 11.2506 21.6133 9.63875C23.1521 8.33005 25.1465 7.54004 27.3258 7.54004Z"
                fill="#F9A000"
            />
        </svg>
    </div>
);

const MicrosoftPay = (
    <div className={css.wrapperSvg}>
        <svg
            width="45"
            height="33"
            viewBox="0 0 45 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.701172 3.53612V29.5439C0.701172 30.9484 1.83824 32.0795 3.24763 32.0795H41.2337C42.6438 32.0795 43.7801 30.9459 43.7801 29.5439V3.53612C43.7801 2.13164 42.6431 1.00055 41.2337 1.00055H3.24763C1.83747 1.00055 0.701172 2.13414 0.701172 3.53612Z"
                fill="white"
                stroke="black"
                strokeOpacity="0.15"
                strokeWidth="0.921053"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.1836 19.9264V12.5608H23.608C24.5268 12.5608 25.1256 12.5976 25.4047 12.6713C25.8334 12.7819 26.1924 13.0222 26.4816 13.3923C26.7708 13.7624 26.9155 14.2406 26.9155 14.8268C26.9155 15.2789 26.8321 15.6591 26.6654 15.9673C26.4986 16.2754 26.2868 16.5174 26.0299 16.6933C25.773 16.8691 25.5118 16.9855 25.2464 17.0425C24.8857 17.1128 24.3634 17.148 23.6795 17.148H22.6944V19.9264H21.1836ZM22.6944 13.8068V15.8969H23.5213C24.1167 15.8969 24.5148 15.8584 24.7156 15.7814C24.9164 15.7043 25.0737 15.5838 25.1877 15.4196C25.3017 15.2555 25.3587 15.0646 25.3587 14.8469C25.3587 14.5789 25.2788 14.3578 25.1188 14.1836C24.9589 14.0095 24.7564 13.9006 24.5114 13.8571C24.3311 13.8236 23.9687 13.8068 23.4243 13.8068H22.6944ZM28.7617 16.2185L27.4602 15.9874C27.6065 15.4715 27.8583 15.0897 28.2156 14.8418C28.5729 14.594 29.1037 14.47 29.8081 14.47C30.4478 14.47 30.9242 14.5446 31.2372 14.6936C31.5503 14.8427 31.7706 15.0319 31.8982 15.2614C32.0258 15.4908 32.0896 15.912 32.0896 16.525L32.0743 18.173C32.0743 18.6419 32.0973 18.9877 32.1432 19.2105C32.1891 19.4332 32.275 19.6719 32.4009 19.9264H30.982C30.9446 19.8327 30.8987 19.6936 30.8442 19.5094C30.8204 19.4257 30.8034 19.3704 30.7932 19.3436C30.5482 19.5781 30.2862 19.7539 30.0071 19.8712C29.7281 19.9884 29.4304 20.047 29.1139 20.047C28.5559 20.047 28.1161 19.898 27.7945 19.5999C27.473 19.3017 27.3122 18.9249 27.3122 18.4694C27.3122 18.1679 27.3853 17.8991 27.5317 17.663C27.678 17.4268 27.883 17.246 28.1467 17.1204C28.4104 16.9947 28.7907 16.8851 29.2875 16.7913C29.9578 16.6673 30.4223 16.5518 30.6809 16.4446V16.3039C30.6809 16.0326 30.6128 15.8392 30.4767 15.7236C30.3406 15.608 30.0837 15.5503 29.706 15.5503C29.4508 15.5503 29.2517 15.5997 29.1088 15.6985C28.9659 15.7973 28.8502 15.9706 28.7617 16.2185ZM30.6809 17.364C30.4971 17.4243 30.2062 17.4963 29.8081 17.5801C29.41 17.6638 29.1497 17.7459 29.0272 17.8263C28.84 17.9569 28.7464 18.1227 28.7464 18.3237C28.7464 18.5213 28.8213 18.6921 28.971 18.8362C29.1207 18.9802 29.3113 19.0522 29.5427 19.0522C29.8013 19.0522 30.048 18.9685 30.2828 18.801C30.4563 18.6737 30.5703 18.518 30.6247 18.3337C30.6622 18.2131 30.6809 17.9837 30.6809 17.6454V17.364ZM32.3689 14.5906H33.8951L35.1915 18.3789L36.4573 14.5906H37.9426L36.0286 19.7255L35.6866 20.655C35.5607 20.9665 35.4407 21.2043 35.3267 21.3684C35.2127 21.5325 35.0817 21.6657 34.9337 21.7679C34.7857 21.87 34.6037 21.9496 34.3876 22.0065C34.1715 22.0634 33.9274 22.0919 33.6552 22.0919C33.3795 22.0919 33.109 22.0634 32.8436 22.0065L32.716 20.9012C32.9406 20.9447 33.1431 20.9665 33.3234 20.9665C33.6569 20.9665 33.9036 20.8702 34.0635 20.6776C34.2234 20.485 34.3459 20.2396 34.431 19.9415L32.3689 14.5906Z"
                fill="#737373"
            />
            <path d="M12.082 10.54H6.24072V16.29H12.082V10.54Z" fill="#FF3E00" />
            <path d="M12.082 16.79H6.24072V22.54H12.082V16.79Z" fill="#00A5F6" />
            <path d="M18.4311 10.54H12.5898V16.29H18.4311V10.54Z" fill="#6BBD00" />
            <path d="M18.4311 16.79H12.5898V22.54H18.4311V16.79Z" fill="#FFB700" />
        </svg>
    </div>
);

const Rechnung = (
    <div className={css.wrapperSvg}>
        <svg
            width="45"
            height="33"
            viewBox="0 0 45 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 3.53566V29.5443C1 30.9489 2.13707 32.08 3.54646 32.08H41.5325C42.9426 32.08 44.0789 30.9464 44.0789 29.5443V3.53566C44.0789 2.13112 42.9419 1 41.5325 1H3.54646C2.1363 1 1 2.13363 1 3.53566Z"
                fill="white"
                stroke="black"
                strokeOpacity="0.15"
                strokeWidth="0.921053"
            />
            <path
                d="M31.125 25.125C31.125 25.4565 30.9933 25.7745 30.7589 26.0089C30.5245 26.2433 30.2065 26.375 29.875 26.375H16.125C15.7935 26.375 15.4755 26.2433 15.2411 26.0089C15.0067 25.7745 14.875 25.4565 14.875 25.125V8.875C14.875 8.54348 15.0067 8.22554 15.2411 7.99112C15.4755 7.7567 15.7935 7.625 16.125 7.625H24.9825C25.3138 7.62507 25.6315 7.75665 25.8658 7.99083L30.7592 12.8842C30.9933 13.1185 31.1249 13.4362 31.125 13.7675V25.125Z"
                stroke="#9E9E9E"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31.125 13.875H26.125C25.7935 13.875 25.4755 13.7433 25.2411 13.5089C25.0067 13.2745 24.875 12.9565 24.875 12.625V7.625"
                stroke="#9E9E9E"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23 19.5H28"
                stroke="#9E9E9E"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.625 23.25H28"
                stroke="#9E9E9E"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31.125 25.125C31.125 25.4565 30.9933 25.7745 30.7589 26.0089C30.5245 26.2433 30.2065 26.375 29.875 26.375H16.125C15.7935 26.375 15.4755 26.2433 15.2411 26.0089C15.0067 25.7745 14.875 25.4565 14.875 25.125V8.875C14.875 8.54348 15.0067 8.22554 15.2411 7.99112C15.4755 7.7567 15.7935 7.625 16.125 7.625H24.9825C25.3138 7.62507 25.6315 7.75665 25.8658 7.99083L30.7592 12.8842C30.9933 13.1185 31.1249 13.4362 31.125 13.7675V25.125Z"
                stroke="#923395"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31.125 13.875H26.125C25.7935 13.875 25.4755 13.7433 25.2411 13.5089C25.0067 13.2745 24.875 12.9565 24.875 12.625V7.625"
                stroke="#923395"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23 19.5H28"
                stroke="#923395"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.625 23.25H28"
                stroke="#923395"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9717 16.877C17.7783 16.877 17.6006 16.832 17.4385 16.7422C17.2754 16.6514 17.1465 16.5264 17.0518 16.3672C16.957 16.208 16.9097 16.0317 16.9097 15.8384C16.9097 15.6577 16.9492 15.4922 17.0283 15.3418C17.1064 15.1914 17.2129 15.0703 17.3477 14.9785L17.5923 15.3345C17.5093 15.3911 17.4438 15.4634 17.396 15.5513C17.3472 15.6392 17.3228 15.7349 17.3228 15.8384C17.3228 16.0093 17.3857 16.1519 17.5117 16.2661C17.6367 16.3794 17.79 16.436 17.9717 16.436C18.1523 16.436 18.3052 16.3794 18.4302 16.2661C18.5542 16.1519 18.6162 16.0093 18.6162 15.8384C18.6162 15.7329 18.5903 15.6353 18.5386 15.5454C18.4868 15.4546 18.4175 15.3804 18.3306 15.3228L18.5767 14.9697C18.7163 15.0615 18.8267 15.1836 18.9077 15.3359C18.9888 15.4873 19.0293 15.6548 19.0293 15.8384C19.0293 15.9829 19.0015 16.1196 18.9458 16.2485C18.8892 16.3774 18.8135 16.4878 18.7188 16.5796C18.624 16.6714 18.5117 16.7441 18.3818 16.7979C18.252 16.8506 18.1152 16.877 17.9717 16.877ZM19 14.6592H16.9331V14.2212H17.7754V13.4858H16.9331V13.042H19V13.4858H18.1694V14.2212H19V14.6592ZM19 12.5557H16.9331V11.2622H17.3198V12.1147H17.7915V11.4395H18.1753V12.1147H19V12.5557Z"
                fill="#923395"
            />
        </svg>
    </div>
);

const Visa = (
    <div className={css.wrapperSvg}>
        <svg
            width="44"
            height="33"
            viewBox="0 0 44 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.460449 3.53612V29.5439C0.460449 30.9484 1.59751 32.0795 3.0069 32.0795H40.9929C42.4031 32.0795 43.5394 30.9459 43.5394 29.5439V3.53612C43.5394 2.13164 42.4023 1.00055 40.9929 1.00055H3.0069C1.59675 1.00055 0.460449 2.13414 0.460449 3.53612Z"
                fill="white"
                stroke="black"
                strokeOpacity="0.15"
                strokeWidth="0.921053"
            />
            <path
                fill="#142A8D"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.5629 21.8537H10.5988L8.37603 13.008C8.27053 12.6011 8.04652 12.2414 7.71701 12.0718C6.89468 11.6458 5.98853 11.3067 5 11.1356V10.7951H9.775C10.434 10.7951 10.9283 11.3067 11.0107 11.9008L12.164 18.2815L15.1266 10.7951H18.0084L13.5629 21.8537ZM19.656 21.8537H16.8566L19.1617 10.7951H21.9611L19.656 21.8537ZM25.5828 13.8587C25.6652 13.263 26.1595 12.9225 26.7361 12.9225C27.6422 12.837 28.6293 13.008 29.4531 13.4326L29.9474 11.0516C29.1236 10.7111 28.2174 10.54 27.3951 10.54C24.6781 10.54 22.701 12.0718 22.701 14.1977C22.701 15.815 24.1015 16.6642 25.09 17.1758C26.1595 17.6859 26.5713 18.0264 26.489 18.5365C26.489 19.3017 25.6652 19.6423 24.8429 19.6423C23.8543 19.6423 22.8658 19.3872 21.9611 18.9611L21.4668 21.3436C22.4554 21.7682 23.5248 21.9392 24.5133 21.9392C27.5599 22.0232 29.4531 20.4929 29.4531 18.196C29.4531 15.3034 25.5828 15.1339 25.5828 13.8587ZM39.2502 21.8537L37.0275 10.7951H34.64C34.1457 10.7951 33.6515 11.1356 33.4867 11.6458L29.3707 21.8537H32.2525L32.8277 20.2379H36.3685L36.698 21.8537H39.2502ZM35.0519 13.7731L35.8742 17.9409H33.5691L35.0519 13.7731Z"
            />
            <defs>
                <linearGradient
                    id="paint0_linear"
                    x1="46.5488"
                    y1="15.384"
                    x2="0.968484"
                    y2="15.384"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#142A8D" />
                    <stop offset="1" stopColor="#191F5F" />
                </linearGradient>
            </defs>
        </svg>
    </div>
);

const paymentConfig = {
    BankIcon: BankIcon,
    Rechnung: Rechnung,
    Visa: Visa,
    MasterCard: MasterCard,
    GooglePay: GooglePay,
    ApplePay: ApplePay,
    MicrosoftPay: MicrosoftPay,
};

const StripePaymentPossibilityIconList = props => {
    const { paymentList = [], rootClass } = props;

    const rootClasses = rootClass ? classNames(css.iconListHolder, rootClass) : css.iconListHolder;

    return (
        <div className={rootClasses}>
            {paymentList && paymentList.length
                ? paymentList.map(l => paymentConfig[l])
                : Object.values(paymentConfig).map((Component, key) =>
                      React.cloneElement(Component, { key })
                  )}
        </div>
    );
};

StripePaymentPossibilityIconList.propTypes = {
    paymentList: array,
};

export default StripePaymentPossibilityIconList;
